import { makeAutoObservable, action, computed } from "mobx";
import { refreshOrGet, userSession } from "../components/security/cognito";

export class AuthStoreImpl {
  authenticated = false;
  session = null;
  roles = [];
  user = null;
  role = null;

  updateUser(user) {
    this.user = user;
    this.role = this.userRole;
  }
  
  setSession(session) {
    this.session = session;
    this.authenticated = true;
  }

  interceptorSetSession(session) {
    this.setSession(session)
  }

  async computeAuthSession() {
    if (this.authenticated && this.session != null) {
      try {
        this.setSession(await refreshOrGet(this.session));
        this.authenticated = true;
      } catch (e) {
        this.authenticated = false;
      }
    }

    try {
      const session = await userSession();
      this.setSession(session);
    } catch (e) {
      this.authenticated = false;
    }
    return this.authenticated;
  }

  get userRole() {
    try {
      if (!this.user.hasOwnProperty("role")) {
        return this.user.org?.main_user === this.user.user_id ? "owner" : "guest";
      } else {
        return this.user.role || "guest";
      }
    } catch {
      return null;
    }
  }

  constructor() {
    makeAutoObservable(this, {
      setSession: action,
      computeAuthSession: action,
      updateUser: action,
      userRole: computed,
      interceptorSetSession: action.bound
    });
  }
}

export const AuthStore = new AuthStoreImpl();
